<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="15.873" height="15.873" viewBox="0 0 15.873 15.873">
    <path class="a" d="M12.873,2.772a2.05,2.05,0,0,1,2.9,2.9L5.987,15.457,2,16.544l1.087-3.987Z"
          transform="translate(-1.25 -1.422)"/>
  </svg>
</template>

<script>
export default {
  name: 'Edit2Icon'
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #8ea2a8;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5px;
}
</style>
